var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "location_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.75.586h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#location_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 12.586c.55 0 1.021-.196 1.413-.588.391-.391.587-.862.587-1.412 0-.55-.196-1.021-.587-1.413a1.928 1.928 0 0 0-1.413-.587c-.55 0-1.02.196-1.412.587a1.927 1.927 0 0 0-.588 1.413c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Zm0 7.35c2.033-1.867 3.542-3.563 4.525-5.088.983-1.525 1.475-2.879 1.475-4.062 0-1.817-.58-3.304-1.738-4.463-1.158-1.158-2.579-1.737-4.262-1.737-1.683 0-3.104.579-4.263 1.737C7.329 7.482 6.75 8.969 6.75 10.786c0 1.183.492 2.537 1.475 4.062.983 1.525 2.492 3.221 4.525 5.088Zm0 2.275c-.133 0-.267-.025-.4-.075a1.198 1.198 0 0 1-.35-.2c-2.433-2.15-4.25-4.146-5.45-5.987-1.2-1.842-1.8-3.563-1.8-5.163 0-2.5.804-4.492 2.413-5.975 1.608-1.483 3.47-2.225 5.587-2.225 2.117 0 3.979.742 5.587 2.225 1.609 1.483 2.413 3.475 2.413 5.975 0 1.6-.6 3.32-1.8 5.163-1.2 1.841-3.017 3.837-5.45 5.987-.1.083-.217.15-.35.2-.133.05-.267.075-.4.075Z"
  }))));
};
export default SvgLocation;